import { persistState, Query, Store } from "@datorama/akita";
import { useObservable, useObservableState } from "observable-hooks";
import { debounceTime } from "rxjs/operators";
import firebase from "firebase/app";

type ColWidthOption = "WIDE" | "MEDIUM" | "COMPACT";
type ColHeightOption = "TALL" | "MEDIUM" | "COMPACT";

export interface AuthState {
  uid?: String;
  displayName?: string | null;
  creds?: firebase.auth.AuthCredential | null;
}

function createInitialState(): AuthState {
  return {};
}

export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialState(), { name: "auth" });
  }
}

export class AuthQuery extends Query<AuthState> {
  constructor(protected store: AuthStore) {
    super(store);
  }
}
export const authStore = new AuthStore();
export const authQuery = new AuthQuery(authStore);

export const useAuth = () => {
  const auth$ = useObservable(() => authQuery.select());
  const auth = useObservableState(auth$);

  return auth;
};
